module.exports = __webpack_public_path__ + "img/LeftButtonRollover.530a3a10.webp";